define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
    const fn = ($scope, StateUtils, submissionViewModel)=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = submissionViewModel();
        const flowModel = StateUtils.activeDataForState(true).flowModel;

        ctrl.init = ()=> {
            $scope.questionSets = submissionVM.draftData.lobs.personalAuto.preQualQuestionSets.value;

            //set default answer of "false" to all the questions
            for (var key in $scope.questionSets[0]["answers"]) {

                $scope.questionSets[0]["answers"][key] = "false" ;

            }

        };

        //hide this page from portal
        flowModel.next(submissionVM,true);

        ctrl.next = (nextFn, form)=> {

            //prequal question requiredness not captured in the submission model, so pass form validity for isValid check
            nextFn(submissionVM, form.valid);
        };


        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel'];

    return fn;
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/controllers/PAPrequalQuestionsCtrl.js
 **/